var map = {
	"./10-12-2020-v2/1024/img/Body_feathers_DiffuseColor.png": "e41c",
	"./10-12-2020-v2/2048/img/Body_feathers_DiffuseColor.png": "654b",
	"./10-12-2020-v2/512/img/Body_feathers_DiffuseColor.png": "df5f",
	"./10-12-2020-v3/1024/img/Body_feathers_DiffuseColor.png": "e057",
	"./10-12-2020-v3/2048/img/Body_feathers_DiffuseColor.png": "55ff",
	"./10-12-2020-v3/512/img/Body_feathers_DiffuseColor.png": "f362"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "88c2";